import React, { useState } from "react";
import { View } from "react-native";
import appStyles from "../../../../appStyles";
import Header from "../../../common/header/index";
import AccountMenuOptions from "../../common/AccountMenuOptions";
import appPages from "../../../../../appPages";
import { INTEGRATION_KEYS } from "../../IntegrationsHelper";
import Account from "./Account";
import SourceReceivedData from "../SourceReceivedData";
import IntegrationFabButton from "../IntegrationFabButton";

export default function AccountsList({
  controller,
  accounts,
  editAccount = () => {},
  toggleAccountStatus = () => {},
  disconnectAccount = () => {},
  goBack = () => {},
}) {
  const [selectedAccount, setSelectedAccount] = useState(null);
  const integrationsRef = React.createRef();

  return (
    <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
      <Header
        title="Apple Health"
        subTitle="Tap for details on which attributes are shared"
        goBack={goBack}
        returnPage={appPages.integrationsV2}
      />

      <View style={{ flex: 1 }}>
        {accounts.map((a, index) => (
          <Account
            controller={controller}
            key={index}
            account={a}
            editAccount={editAccount}
            toggleAccountStatus={toggleAccountStatus}
            onLongPress={() => setSelectedAccount(a)}
          />
        ))}

        {/* All data */}
        <SourceReceivedData
          ref={integrationsRef}
          sourceName={INTEGRATION_KEYS.health}
          controller={controller}
        />
      </View>

      <IntegrationFabButton
        refresh={() => {
            controller.getItems();
          integrationsRef.current.loadData();
        }}
      />

      <AccountMenuOptions
        controller={controller}
        account={selectedAccount}
        accounts={accounts}
        close={() => setSelectedAccount(null)}
        disconnectAccount={disconnectAccount}
        integrationName={INTEGRATION_KEYS.health}
      />
    </View>
  );
}
